export default {
  data () {
    return {
      groupActions: [
        {
          label: this.$t('inspection.operation.inspect'),
          action: () => {
            this.createDialog('InspectDialog', {
              success: () => {
                this.list.fetchData()
              },
            })
            // this.doInspectionHandle()
          },
          meta: () => {
            return {
              buttonType: 'primary',
              validate: true,
            }
          },
        },
        {
          label: this.$t('common.batchAction'),
          actions: () => {
            return [
              {
                label: this.$t('table.action.delete'),
                action: () => {
                  this.createDialog('DeleteResDialog', {
                    vm: this,
                    data: this.list.selectedItems,
                    columns: this.columns,
                    title: this.$t('table.action.delete'),
                    name: this.$t('inspection.report'),
                    onManager: this.onManager,
                  })
                },
                meta: () => {
                  const ret = { validate: this.list.selected.length }
                  if (this.list.selectedItems.some(item => !item.can_delete)) {
                    ret.validate = false
                    return ret
                  }
                  return ret
                },
                hidden: () => true,
              },
            ]
          },
        },
      ],
    }
  },
}
